import Vue from 'vue'
import axios from 'axios'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import VueMq from 'vue-mq'

Vue.use(VueMq, {
  breakpoints: {
    xs: 600,
    sm: 960,
    md: 1264,
    lg: 1904,
    xl: Infinity
  }
})

// replace fetch() base urls too
axios.defaults.baseURL = '/api/kleen/api'
axios.defaults.withCredentials = true

Vue.config.productionTip = false

// set up a global variable on vue with data coming from django
// see /twip_web/templates/twip_web/base.html
const ENVIRONMENT = JSON.parse(document.getElementById('environment').textContent)

// provide the global constant to vue js (vuejs don't have access to globals otherwise)
Vue.prototype.$ENVIRONMENT = ENVIRONMENT

// load sentry only for integration/staging/prodution
if (ENVIRONMENT === 'integration') {
  Raven
    .config('https://7fe1258ae0135eb6823d1f9457914e22@o4508007013875712.ingest.de.sentry.io/4508166946422864')
    .addPlugin(RavenVue, Vue)
    .install()
}
else if (ENVIRONMENT === 'staging') {
  Raven
    .config('https://7fe1258ae0135eb6823d1f9457914e22@o4508007013875712.ingest.de.sentry.io/4508166946422864')
    .addPlugin(RavenVue, Vue)
    .install()
}
else if (ENVIRONMENT === 'production') {
  Raven
    .config('https://7fe1258ae0135eb6823d1f9457914e22@o4508007013875712.ingest.de.sentry.io/4508166946422864')
    .addPlugin(RavenVue, Vue)
    .install()
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
